<ng-container *ngIf="vm$ | async as vm">
  <aside class="generation-progress">
    <div
      class="generation-progress__info"
      [ngClass]="{'visually-hidden': !vm.expanded}"
      [attr.aria-hidden]="!vm.expanded">
      <h4 class="generation-progress__title">
        {{ 'GPT_STORIES.GENERATION_PROGRESS_TITLE' | translate }}
      </h4>
      <p class="generation-progress__status">
        {{
          'GPT_STORIES.GENERATION_PROGRESS_STATUS'
            | translate
              : {
                  completed: vm.generationStatus.completed,
                  total: vm.generationStatus.total
                }
        }}
      </p>
    </div>

    <button
      mat-mini-fab
      class="generation-progress__toggle-button"
      (click)="toggle()"
      [attr.aria-expanded]="vm.expanded"
      [disableRipple]="vm.generationFinished"
      [disabled]="vm.generationFinished">
      <mat-icon
        *ngIf="vm.expanded || vm.generationFinished; else loadingTemplate"
        aria-label="close"
        aria-hidden="false"
        svgIcon="close"
        class="toggle-button__icon"></mat-icon>

      <ng-template #loadingTemplate>
        <mat-spinner></mat-spinner>
      </ng-template>
    </button>
  </aside>
</ng-container>
